/**
 * @generated SignedSource<<fd5365889b8b8be81a1e93ac038ced6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaEditorPreviews_media$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MediaEditorThumb_media">;
    };
  }>;
  readonly " $fragmentType": "MediaEditorPreviews_media";
};
export type MediaEditorPreviews_media$key = {
  readonly " $data"?: MediaEditorPreviews_media$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaEditorPreviews_media">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaEditorPreviews_media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Media",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MediaEditorThumb_media"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MediaConnection",
  "abstractKey": null
};

(node as any).hash = "65132c1e8223d2141ad4e216f7807b40";

export default node;
